module.exports = "/_next/static/images/LinkedIn-802fd903c5aada041eced14ec7f77737.svg";